import { Accordion, AccordionPanel, Box, Button, Layer, ResponsiveContext } from "grommet";
import { FormClose, Menu as IconMenu } from "grommet-icons";
import React from "react";
import { NameSpace } from "../../const/namespace";
import { authPage, headerLinks, MenuItems } from "../../mocks/headerLinks";
import { MainLogo } from "../MainLogo";
import { BasketButton } from "../Buttons/BasketButton";
import { CustomLink, CustomMenu, MenuNavLink, HoverMenuNavLink, ModalMenuSubItem } from "./styles";
export var Header = function Header(_ref) {
  var goods = _ref.goods,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? "a" : _ref$as;

  var _React$useState = React.useState(false),
    mobileMenu = _React$useState[0],
    setMobileMenu = _React$useState[1];

  return /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
    return /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        justify: "between",
        direction: "row",
        pad: {
          horizontal: "medium",
          vertical: "small",
        },
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          alignSelf: "center",
          pad: {
            left: "12px",
            top: "10px",
          },
        },
        /*#__PURE__*/ React.createElement(MainLogo, {
          as: as,
        })
      ),
      size !== NameSpace.miniMobile &&
        size !== NameSpace.mobile &&
        size !== NameSpace.tablet &&
        size !== NameSpace.desktop1200
        ? /*#__PURE__*/ React.createElement(
            Box,
            {
              direction: "row",
              gap: "12px",
              align: "center",
              justify: "end",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                direction: "row",
              },
              MenuItems.map(function (menu) {
                return /*#__PURE__*/ React.createElement(CustomMenu, {
                  key: menu.name,
                  label: menu.name,
                  size: "small",
                  dropProps: {
                    align: {
                      top: "bottom",
                      left: "left",
                    },
                  },
                  items: menu.array.map(function (el) {
                    return {
                      label: /*#__PURE__*/ React.createElement(
                        MenuNavLink,
                        {
                          as: as,
                          to: el.path,
                        },
                        el.name
                      ),
                      hoverIndicator: {
                        color: "#e21a25",
                      },
                      onClick: function onClick() {},
                    };
                  }),
                });
              })
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              {
                direction: "row",
                gap: "26px",
                pad: "xsmall",
              },
              headerLinks.map(function (el) {
                return /*#__PURE__*/ React.createElement(
                  HoverMenuNavLink,
                  {
                    as: as,
                    to: el.path,
                    key: el.name,
                  },
                  el.name
                );
              })
            )
          )
        : /*#__PURE__*/ React.createElement(
            Box,
            {
              direction: "row",
              flex: true,
              justify: "end",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                justify: "center",
                align: "end",
              },
              /*#__PURE__*/ React.createElement(Button, {
                icon: /*#__PURE__*/ React.createElement(IconMenu, null),
                onClick: function onClick() {
                  setMobileMenu(true);
                },
              })
            ),
            mobileMenu &&
              /*#__PURE__*/ React.createElement(
                Layer,
                {
                  full: true,
                },
                /*#__PURE__*/ React.createElement(
                  Box,
                  {
                    pad: {
                      horizontal: "16px",
                    },
                    direction: "row",
                    justify: "end",
                  },
                  /*#__PURE__*/ React.createElement(Button, {
                    icon: /*#__PURE__*/ React.createElement(FormClose, null),
                    onClick: function onClick() {
                      setMobileMenu(false);
                    },
                  })
                ),
                /*#__PURE__*/ React.createElement(
                  Accordion,
                  {
                    pad: {
                      horizontal: "12px",
                    },
                  },
                  MenuItems.map(function (el) {
                    return /*#__PURE__*/ React.createElement(
                      AccordionPanel,
                      {
                        key: el.name,
                        pad: "10px",
                        label: el.name,
                      },
                      el.array.map(function (arr) {
                        return /*#__PURE__*/ React.createElement(
                          ModalMenuSubItem,
                          {
                            as: as,
                            key: arr.name,
                            to: arr.path,
                            onClick: function onClick() {
                              setMobileMenu(false);
                            },
                          },
                          arr.name
                        );
                      })
                    );
                  }),
                  headerLinks.map(function (el) {
                    return /*#__PURE__*/ React.createElement(
                      CustomLink,
                      {
                        as: as,
                        to: el.path,
                        key: el.name,
                        onClick: function onClick() {
                          setMobileMenu(false);
                        },
                      },
                      el.name
                    );
                  })
                )
              )
          )
    );
  });
};
